import React from 'react';
import { Link } from 'react-router-dom';
import WhatsAppLeadForm from '../components/WhatsAppLeadForm';
import '../scss/whatsapp-edevcode.scss';

const plans = [
  {
    name: 'Start API',
    price: 'R$ 297/mes',
    description: 'Para quem esta iniciando no envio e atendimento oficial.',
    features: [
      '1 numero oficial conectado',
      'Disparo com segmentacao basica',
      'Painel com historico das conversas',
      'Suporte tecnico em horario comercial',
    ],
  },
  {
    name: 'Pro API',
    price: 'R$ 597/mes',
    description: 'Plano mais vendido para operacao comercial ativa.',
    highlighted: true,
    features: [
      'Ate 3 atendentes simultaneos',
      'Fluxos automaticos de funil e suporte',
      'Etiquetas, filas e distribuicao inteligente',
      'Metricas de entrega, leitura e resposta',
    ],
  },
  {
    name: 'Scale API',
    price: 'Sob consulta',
    description: 'Para alto volume com integracoes corporativas.',
    features: [
      'Multi numeros e multi departamentos',
      'Integracao com CRM, ERP e ecommerce',
      'SLA premium e acompanhamento estrategico',
      'Arquitetura para grandes operacoes',
    ],
  },
];

const trustBadges = [
  'API oficial da Meta',
  'Sem risco de bloqueio por ferramenta paralela',
  'Atendimento humano + automacao no mesmo fluxo',
  'Operacao pronta para vender e escalar',
];

const faqs = [
  {
    question: 'Esse servico usa API oficial do WhatsApp?',
    answer:
      'Sim. A operacao e estruturada na API oficial da Meta, com regras de template, qualidade e compliance.',
  },
  {
    question: 'Eu consigo enviar campanha e tambem atender clientes?',
    answer:
      'Sim. O mesmo ambiente permite disparo, chatbot, fila de atendimento e resposta humana com historico completo.',
  },
  {
    question: 'Tem plano para empresa pequena?',
    answer:
      'Sim. O Start API foi desenhado para pequenas operacoes e pode evoluir para Pro API conforme seu volume cresce.',
  },
  {
    question: 'O que e Whatlist no atendimento?',
    answer:
      'Whatlist e a fila organizada de conversas por prioridade, time e SLA, ajudando sua equipe a responder primeiro o que gera mais resultado.',
  },
];

export default function WhatsAppEdevcodeLanding() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="whatsapp-edevcode">
      <header className="wec-topbar">
        <a href="#topo" className="wec-brand" aria-label="esdevcode zap">
          <img src="/images/whatsapp-edv-logo.svg" alt="esdevcode zap" />
        </a>

        <nav className="wec-nav-links" aria-label="Navegacao principal">
          <a href="#planos">Planos API</a>
          <a href="#video">Video</a>
          <a href="#faq">FAQ</a>
        </nav>

        <a className="wec-btn wec-btn-secondary" href="#proposta">
          Criar conta
        </a>
      </header>

      <section id="topo" className="wec-hero wec-hero-alt">
        <div className="wec-hero-copy" data-aos="fade-up">
          <p className="wec-kicker">esdevcode zap</p>
          <h1>Disparo em massa e atendimento no WhatsApp com API oficial.</h1>
          <p className="wec-subtitle">
            Estruture uma operacao profissional para vender, cobrar e atender com
            confianca. Sem gambiarra, sem ferramenta de risco, com suporte real
            para sua empresa escalar.
          </p>
          <div className="wec-hero-actions">
            <a className="wec-btn wec-btn-primary" href="#proposta">
              Criar conta agora
            </a>
            <a className="wec-btn wec-btn-secondary" href="#planos">
              Ver planos
            </a>
          </div>
          <p className="wec-note">Nenhum cartao de credito para iniciar o contato comercial.</p>
        </div>

        <aside className="wec-hero-panel" data-aos="fade-left">
          <h2>Confianca para seu cliente final</h2>
          <ul>
            {trustBadges.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <a className="wec-btn wec-btn-primary wec-btn-block" href="#proposta">
            Quero proposta personalizada
          </a>
        </aside>
      </section>

      <section id="video" className="wec-section wec-video-section">
        <div className="wec-section-heading" data-aos="fade-up">
          <p>Video de demonstracao</p>
          <h2>Estilo direto de vendas para apresentar o esdevcode zap.</h2>
        </div>

        <div className="wec-video-grid" data-aos="fade-up">
          <div className="wec-video-frame">
            <iframe
              src="https://www.youtube.com/embed/Uwomb1smClk"
              title="Referencia de video promocional"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          <div className="wec-video-copy">
            <h3>Video no mesmo formato da referencia</h3>
            <p>
              O layout ja esta pronto para usar um video promocional com sua
              marca esdevcode zap, focado em plano, prova de confianca e chamada
              para acao.
            </p>
            <ul>
              <li>Abertura com impacto comercial em ate 3 segundos</li>
              <li>Demonstracao de envio, fila e atendimento Whatlist</li>
              <li>Fechamento com CTA para assinatura do plano</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="planos" className="wec-section wec-pricing wec-pricing-alt">
        <div className="wec-section-heading" data-aos="fade-up">
          <p>Planos API Oficial</p>
          <h2>Escolha o plano ideal para sua operacao comercial no WhatsApp.</h2>
        </div>
        <div className="wec-plans">
          {plans.map((plan) => (
            <article
              key={plan.name}
              className={`wec-plan ${plan.highlighted ? 'is-highlighted' : ''}`}
              data-aos="zoom-in"
            >
              <h3>{plan.name}</h3>
              <p className="wec-price">{plan.price}</p>
              <p className="wec-plan-audience">{plan.description}</p>
              <ul>
                {plan.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <a className="wec-btn wec-btn-secondary wec-btn-block" href="#proposta">
                Contratar {plan.name}
              </a>
            </article>
          ))}
        </div>
      </section>

      <section id="faq" className="wec-section wec-faq">
        <div className="wec-section-heading" data-aos="fade-up">
          <p>Perguntas frequentes</p>
          <h2>Respostas rapidas para contratar com seguranca.</h2>
        </div>
        <div className="wec-faq-grid" data-aos="fade-up">
          {faqs.map((item) => (
            <article key={item.question} className="wec-faq-item">
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="proposta" className="wec-section wec-conversion">
        <div className="wec-conversion-copy" data-aos="fade-right">
          <p className="wec-kicker">Crie sua conta agora</p>
          <h2>Receba a proposta ideal para o seu volume de mensagens.</h2>
          <p>
            Informe seu objetivo e volume mensal. Retornamos com arquitetura,
            plano recomendado e previsao de implantacao.
          </p>
          <div className="wec-contact-points">
            <span>Email comercial: emerson.farias@esdevcode.com.br</span>
            <span>Marca: esdevcode zap</span>
          </div>
        </div>
        <div className="wec-conversion-form" data-aos="fade-left">
          <WhatsAppLeadForm />
        </div>
      </section>

      <section className="wec-section wec-legal-info">
        <div className="wec-section-heading" data-aos="fade-up">
          <p>Base legal e empresarial</p>
          <h2>Dados oficiais para transparencia da contratacao.</h2>
        </div>
        <dl className="wec-company-data" data-aos="fade-up">
          <div>
            <dt>Razao social</dt>
            <dd>54.240.100 EMERSON DE FARIAS SANTOS</dd>
          </div>
          <div>
            <dt>CNPJ</dt>
            <dd>54.240.100/0001-14</dd>
          </div>
          <div>
            <dt>Situacao cadastral</dt>
            <dd>ATIVA desde 07/03/2024</dd>
          </div>
          <div>
            <dt>Endereco comercial</dt>
            <dd>
              Avenida Cuiaba, 95, APT 401, Planalto Boa Esperanca, Joao
              Pessoa/PB, CEP 58065-048
            </dd>
          </div>
        </dl>
      </section>

      <footer className="wec-footer">
        <p>© {currentYear} esdevcode zap. Todos os direitos reservados.</p>
        <div className="wec-footer-links">
          <Link to="/whatsapp/politica-de-privacidade">Politica de Privacidade</Link>
          <Link to="/whatsapp/termos-de-servico">Termos de Servico</Link>
        </div>
      </footer>
    </div>
  );
}
